import React from 'react'
import { Typography } from 'antd'
import './styles.modules.scss'
import { defaultSortOrder } from '../../../../../utils/table/defaultSortOrder'
import { columnSortTooltip } from '../../../../../utils/table/columnSortTooltip'
import { SORT_TEXTS } from '../../../../../constants/COLUMN_SORTER'

export const ProductNameColumn = (sortColumn: string, sortOrder: string) => {
  return {
    title: 'Product',
    dataIndex: 'productName',
    defaultSortOrder: defaultSortOrder('productName', sortColumn, sortOrder),
    showSorterTooltip: columnSortTooltip({
      dataIndex: 'productName',
      sortColumn: sortColumn,
      sortOrder: sortOrder,
      ascText: SORT_TEXTS.CHAR_ASC,
      descText: SORT_TEXTS.CHAR_DESC,
      cancelText: SORT_TEXTS.CANCEL
    }),
    sorter: true,
    className: 'table-column product-name-column',
    render: (productName: string | null) => {
      return <Typography.Text>{productName}</Typography.Text>
    }
  }
}
